<script lang="ts">
  import { ICONS, type IconName } from './icon-map';

  let {
    name,
    size = 16,
    stroke,
    label,
    class: className = ''
  }: {
    name: IconName;
    size?: 12 | 14 | 16 | 18 | 20 | 24 | 32 | 48;
    stroke?: number;
    label?: string;
    class?: string;
  } = $props();

  const Component = $derived(ICONS[name]);

  // Stroke por tamaño: <16 sube, >=24 baja
  const computedStroke = $derived(
    stroke ?? (size <= 12 ? 2.25 : size >= 48 ? 1.5 : size >= 32 ? 1.75 : 2)
  );

  const a11y = $derived(
    label
      ? { role: 'img' as const, 'aria-label': label }
      : { 'aria-hidden': 'true' as const, focusable: 'false' as const }
  );
</script>

<Component
  size={size}
  strokeWidth={computedStroke}
  class={className}
  {...a11y}
/>